import { render, staticRenderFns } from "./CopTiposVisita.vue?vue&type=template&id=7c2b751b&scoped=true"
import script from "./CopTiposVisita.vue?vue&type=script&lang=js"
export * from "./CopTiposVisita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2b751b",
  null
  
)

export default component.exports